import React from "react";

function BS4_Modal() {
  return (
    <div>
      <h1>BS4_Modal Component</h1>
      <p>This is the BS4_Modal tutorial page content.</p>
    </div>
  );
}

export default BS4_Modal;
